import { render, staticRenderFns } from "./CloseSavingsAccount.vue?vue&type=template&id=c3dd8d98"
import script from "./CloseSavingsAccount.vue?vue&type=script&lang=js"
export * from "./CloseSavingsAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports